import * as React from 'react';
import styled from 'styled-components';
import Box from '../../../components/Box';
import VideoPreview from './VideoPreview';

interface CandidateAvatarProps extends React.HTMLProps<HTMLButtonElement> {
    videoId: string | undefined;
    firstLine: string;
    secondLine: string;
    selected: boolean;
    onClick: () => void;
}

const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 8em;
    margin-right: 1em;
    padding: 0;
    border-radius: 0.5em;
    overflow: hidden;
    cursor: pointer;

    h3 {
        margin-left: 1em;
        margin-right: 1em;
    }
`;

const CandidateAvatar: React.FC<CandidateAvatarProps> = props => (
    <Container selected={props.selected} onClick={props.onClick}>
        <VideoPreview videoId={props.videoId} />
        <h3>
            {props.firstLine}
            <br />
            {props.secondLine}
        </h3>
    </Container>
);

export default CandidateAvatar;



// WEBPACK FOOTER //
// ./src/scenes/hiring-manager/components/CandidateAvatar.tsx